export function versionedRailwayProjectName(base: string, attempt: number): string {
  return attempt <= 1 ? base : `${base}-v${attempt}`
}
